import React, { Fragment, useEffect, useReducer, useRef, useState } from 'react'
import { KTSVG } from '../../../_metronic/helpers'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { holidayTypeInitialsForAdd, holidayTypeInitialsForUpdate } from './interfaces/holidayTypeClass';
import { addHolidayTypeAsync, updateHolidayTypeAsync, resetSelectedRecordObjectInState } from './holidayTypeSlice';
import { displayValueForTimeEntry } from '../../../common/timesheetFunction';
import * as yup from 'yup';
import { Formik } from 'formik';
import { dropDownSelectionStyles , getValueFromResource} from '../../../common/timeLiveFunction';
import { ShowToast } from '../../../common/Toastr';
import fetchAPI from '../../../common/fetchAPI';
import Select, { StylesConfig } from 'react-select';

const HolidayTypeForm = (props: any) => {

    const { modelRef, t, oncloseModal } = props;
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const { maxMenuHeight } = useAppSelector(state => state.globalState);
    const [disabledCount, setDisabledCount] = useState(0)
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(holidayTypeInitialsForAdd);
    const { selectedRecord, isLoading, holidayTypeList } = useAppSelector((state) => state.holidayType);
    const [ParentHolidayTypeArray, SetParentHolidayTypeArray] = useState<any | ''>([]);
    const [selectedOptionHolidayType, setselectedOptionHolidayType] = useState<{ value: string; label: string } | null>(null);
    const dispatch = useAppDispatch();


    const renderHolidayTypes = async () => {

        const response = await fetchAPI('api/v2/HolidayTypes/GetAllDataInSingleRequest', "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
        const json = await response.json();
        const holidayTypes = json["Active Parent Account Holiday Type"].map((item: any) => {
            return {
                value: item.AccountHolidayTypeId,
                label: item.AccountHolidayType,
            };
        });
        const defaultOption = { value: "00000000-0000-0000-0000-000000000000", label: "None" };
        const parentHolidayTypeArray = [defaultOption, ...holidayTypes];

        SetParentHolidayTypeArray(parentHolidayTypeArray);
    }

    useEffect(() => {
        renderHolidayTypes();
    }, []);

    useEffect(() => {
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;    
            Object.keys(holidayTypeInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })

            stateItem.IsParent = stateItem.IsParent === 'Yes' ? true : false;
            stateItem.IsDisabled = stateItem.IsDisabled === 'Yes' ? true : false;

            if (tempObj.ParentAccountHolidayTypeId !== null) {
                setselectedOptionHolidayType(ParentHolidayTypeArray.find((HolidayType: any) => HolidayType.value == stateItem.ParentAccountHolidayTypeId));
            }

            setCurrentFieldsData(stateItem);
        }
        else {
            setCurrentFieldsData(holidayTypeInitialsForAdd);
        }
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }

        calculatedDisabledValue();
    }, [selectedRecord])





    const handleSubmit = (values: any) => {
        if (Object.keys(selectedRecord).length > 0) {
            dispatch(updateHolidayTypeAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Holiday type Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
        else {
            dispatch(addHolidayTypeAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "201" ?
                        ShowToast("Holiday type Added Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
        oncloseModal();
    }


    const calculatedDisabledValue = () => {
        if (holidayTypeList.length > 0) {
            let index = 0;
            holidayTypeList.forEach((value) => {
                if (value.IsDisabled.toString() == 'Yes') {
                    index = index + 1
                }
            });
            setDisabledCount(holidayTypeList.length - index);
        }
    }
    return (
        <>
            <Formik
                initialValues={currentFieldsData}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    AccountHolidayType: yup
                        .string()
                        .label('AccountHolidayType')
                        .trim()
                        .required
                        // (t('Holiday type is required'))
                        (getValueFromResource('Holiday type is required', dispatch, t))
                })}>
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                        <form>
                            <div className='card-body'>
                                {isLoading ?
                                    <div className="col-md-12">
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                            <span className='spinner-border spinner-border-md ms-2'></span>
                                        </span>
                                    </div>
                                    : <>
                                        <div className="modal drawer-overlay" style={{ display: 'block' }}
                                        >
                                            <div className="modal-dialog">
                                                <div className="modal-content">
                                                    <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                                                        <h5 className="modal-title mainHeading">{Object.keys(selectedRecord).length > 0 ? 
                                                        // t('Update') 
                                                        getValueFromResource('Update ',dispatch, t)

                                                        :
                                                        //  t('Add')} 
                                                        getValueFromResource('Add ',dispatch, t)}

                                                         {/* {t('Holiday Type')}  */}
                                                         {getValueFromResource('Holiday Type',dispatch, t)}
                                                         </h5>
                                                        <div
                                                            className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                                            onClick={oncloseModal}
                                                        >
                                                            <KTSVG
                                                                path="/media/icons/duotune/arrows/arr061.svg"
                                                                className="svg-icon svg-icon-1x"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="modal-body">
                                                        <form className='form'>
                                                            <div className='row'>
                                                                <div className="mb-0">
                                                                    <label className="fs-7 fs-7 fw-normal mb-2">
                                                                        {/* {t('Parent Holiday Type')} */}
                                                                        {getValueFromResource('Parent Holiday Type',dispatch, t)}
                                                                        </label>
                                                                    <Select
                                                                        // value={ParentHolidayTypeArray.find((option: any) => option.value == values.AccountHolidayTypeId)}
                                                                        value={
                                                                            values.ParentAccountHolidayTypeId
                                                                                ? ParentHolidayTypeArray.find((option: any) => option.value == values.ParentAccountHolidayTypeId)
                                                                                : { value: "00000000-0000-0000-0000-000000000000", label: "None" }
                                                                        }
                                                                        className="basic-single"
                                                                        classNamePrefix="select"
                                                                        isSearchable={true}
                                                                        name="ParentAccountHolidayTypeId"
                                                                        onBlur={() => setFieldTouched('ParentAccountHolidayTypeId', true)}
                                                                        onChange={(selectedOption) => {
                                                                            handleChange({
                                                                                target: {
                                                                                    id: "ParentAccountHolidayTypeId",
                                                                                    value: selectedOption?.value
                                                                                },
                                                                            });
                                                                        }}
                                                                        options={ParentHolidayTypeArray}
                                                                        styles={dropDownSelectionStyles}
                                                                        maxMenuHeight={maxMenuHeight}
                                                                    />
                                                                </div>
                                                                <div className="mb-0 mt-2">
                                                                    <label className="fs-7 fw-normal mb-2">
                                                                        {/* {t('Is Parent')} */}
                                                                        {getValueFromResource('Is Parent',dispatch, t)}

                                                                        </label>
                                                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                        <input className="form-check-input h-20px w-30px"
                                                                            type="checkbox"
                                                                            checked={values.IsParent}
                                                                            id="IsParent"
                                                                            onChange={handleChange('IsParent')}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>


                                                            <div className="mb-0" style={{ marginTop: '10px' }}>
                                                                <label className="fs-7 fs-7 fw-normal mb-2">
                                                                    {/* {t('Holiday Type')} */}
                                                                    {getValueFromResource('Holiday Type',dispatch, t)}

                                                                    </label>
                                                                <input type="text" className="form-control fs-7 fw-normal" id='AccountHolidayType' value={values.AccountHolidayType} name='AccountHolidayType'
                                                                    onChange={handleChange('AccountHolidayType')}
                                                                    style={{ color: '#172b4d' }}
                                                                    ref={defaultFocusRef}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            e.preventDefault();
                                                                            setFieldTouched('AccountHolidayType', true);
                                                                            handleSubmit();
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div style={{ paddingRight: 5 }}>
                                                                {touched.AccountHolidayType && errors.AccountHolidayType &&
                                                                    <p className='errorMsg'>{errors.AccountHolidayType as string}</p>
                                                                }
                                                            </div>

                                                            {/* {Object.keys(selectedRecord).length > 0 ? (
                                                                <div className="mb-0" >
                                                                    <label className="fs-7 fw-normal mt-2">{t('Disabled')}</label>
                                                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                        <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                                            onChange={handleChange('IsDisabled')}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            ) : null} */}

                                                            {Object.keys(selectedRecord).length > 0 ? (
                                                                disabledCount !== 1 ? <div className="mb-3" >
                                                                    <label className="fs-7 fw-normal mt-2">
                                                                        {/* {t('Disabled')} */}
                                                                        {getValueFromResource('Disabled',dispatch, t)}

                                                                        </label>
                                                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                        <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                                            onChange={handleChange('IsDisabled')}
                                                                        />
                                                                    </div>
                                                                </div> : holidayTypeList.find(x => x.AccountHolidayTypeId === values.AccountHolidayTypeId)?.IsDisabled.toString() === "Yes" && (<div className="mb-3" >
                                                                    <label className="fs-7 fw-normal mt-2">
                                                                        {/* {t('Disabled')} */}
                                                                        {getValueFromResource('Disabled',dispatch, t)}

                                                                        </label>
                                                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                        <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                                            onChange={handleChange('IsDisabled')}
                                                                        />
                                                                    </div>
                                                                </div>)
                                                            ) : null}
                                                        </form>
                                                    </div>
                                                    <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                                            onClick={oncloseModal}
                                                        >
                                                            {/* {t('Cancel')} */}
                                                            {getValueFromResource('Cancel',dispatch, t)}

                                                        </button>
                                                        <button type="button" className="btn btn-primary  btn-bs-btn-font-weight btn-sm" onClick={() => handleSubmit()} disabled={!isValid}>
                                                            {/* {t('Save')} */}
                                                            {getValueFromResource('Save',dispatch, t)}

                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </form>
                    </Fragment>
                )}
            </Formik>
        </>
    )

}

export default HolidayTypeForm
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}